import {call , put} from 'redux-saga/effects';
import {dashboardService} from '../services/dashboardService'
import { dashboardConstants } from '../actions/constants/dashboardConstants';

function* getDashboard (action: any) : any {
    try {
        const response = yield call(dashboardService.getDashboard, action.payload);
        if(response && response.success){
            yield put({type : dashboardConstants.getDashboardSuccess, payload : response.resultObject})
        }else {
            yield put({type : dashboardConstants.getDashboardFailure, payload : response})
        }
    } catch (error) {
        yield put({type : dashboardConstants.getDashboardFailure, payload : error})
    }
}

export const dashboardSaga = {
    getDashboard
}